export default __webpack_public_path__ + "static/easy-setup-6f18d406d92130b9a78cb6f8c391f578.svg";